module.exports = __webpack_public_path__ + "static/newsletter-e51d78e14aaa35ce7052e0141880dcd6.jpg";